"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingReason = void 0;
var ReadingReason;
(function (ReadingReason) {
    ReadingReason["PERIODIC_READING"] = "Periodieke opname";
    ReadingReason["FLEXIBLE_READING_WITH_BILLING"] = "Tussentijdse opname met afrekening";
    ReadingReason["LAST_READING_MOVING"] = "Slotopname verhuizing";
    ReadingReason["CERTIFICATE_READING"] = "Certificatie-opname";
    ReadingReason["AREA_PAYMENT_WITH_SETTLEMENT"] = "Gebiedsafdracht met afrekening";
    ReadingReason["INTERNAL_READING"] = "Inhuizingsopname";
    ReadingReason["AREA_PAYMENT_WITHOUT_SETTLEMENT"] = "Gebiedsafdracht zonder afrekening";
    ReadingReason["RECORDING_FOR_TECHNICAL_INSTALLATION"] = "Opname voor technische inbouw";
    ReadingReason["FLEXIBLE_READING_WITHOUT_BILLING"] = "Tussentijdse opname zonder afrekening";
    ReadingReason["RE_ADMISSION"] = "Heropname";
    ReadingReason["READING_AFTER_PROGRAMMING"] = "Opname na programmering/aanpassing";
    ReadingReason["RECORDING_FOR_TECHNICAL_EXPANSION"] = "Opname voor technische uitbouw";
    ReadingReason["RECORDING_AT_THE_END_OF_THE_INSTALLATION"] = "Opname bij afsluiting installatie";
    ReadingReason["AUTOMATICALLY_CALCULATED_AT_LIMIT"] = "Automatisch berekend bij begrenzing";
    ReadingReason["TRANSPORT_RECORDING"] = "Transportopname";
    ReadingReason["RECORDING_FOR_PROGRAMMING_OR_ADJUSTMENT"] = "Opname voor programmering/aanpassing";
    ReadingReason["RECORDING_WHEN_INSTALLATION_STRUCTURE_IS_CHANGED"] = "Opname bij wijziging installatiestruct.";
    ReadingReason["RECONNECTION_RECORDING"] = "Heraansluitingsopname";
    ReadingReason["DELIVERY_RECORDING"] = "Leveringsopname";
    ReadingReason["DEVICE_RE_RECORDING"] = "Apparaatheropname";
    ReadingReason["READING_BEFORE_PHYSICAL_INSTALLATION"] = "Opname voor afrekeningstechnische inbouw";
    ReadingReason["INCLUSION_FOR_BILLING_TECHNICAL_EXPANSION"] = "Opname voor afrekeningstechn. uitbouw";
    ReadingReason["ONE_TIME_RECORDING_CONVERSION"] = "Eenmalige opname ombouw";
    ReadingReason["REPLACEMENT_BUILT_IN"] = "Vervanging inbouw";
    ReadingReason["REPLACEMENT_EXTENSION"] = "Vervanging uitbouw";
    ReadingReason["NEW_CONTRACT"] = "Nieuw contract";
    ReadingReason["OTHER_DEBTOR"] = "Andere debiteur";
    ReadingReason["RECORDING_BEFORE_CHANGE_LOG_COUNTER_NUMBER"] = "Opname v\u00F3\u00F3r wijziging log. telwerknummer";
    ReadingReason["RECORDING_AFTER_CHANGE_LOG_COUNTER_NUMBER"] = "Opname na wijziging log. telwerknummer";
    ReadingReason["START_SIMULATION"] = "Begin simulatie";
    ReadingReason["END_SIMULATION"] = "Einde simulatie";
    ReadingReason["MISSING"] = "";
})(ReadingReason = exports.ReadingReason || (exports.ReadingReason = {}));
